import { Button, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Home } from "lucide-react";
import type { FallbackProps } from "react-error-boundary";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { UnauthenticatedLayout } from "web_myplann/Shared/Layouts/UnauthenticatedLayout";
import { clearPersistedQueryCache } from "web_myplann/Shared/QueryClient";
import { WebViewMessageTypes } from "web_myplann/Utils/WebViewModel";

export const ApplicationErrorPage: React.FunctionComponent<FallbackProps> = (
	props,
) => {
	const { error } = props;
	const { t } = useResource();
	const queryClient = useQueryClient();
	console.log("error", error);

	return (
		<UnauthenticatedLayout title={"Chyba"}>
			<Typography variant="deprecatedH4">
				Je nám líto v aplikaci došlo k chybě.
			</Typography>
			<br />
			<Typography>
				Naši programátoři již o chybě byli informování a na opravě už pracují.
			</Typography>
			<br />

			<Button
				startIcon={<Home />}
				size="large"
				variant="contained"
				color="primary"
				onClick={() => {
					clearPersistedQueryCache(queryClient);
					window.ReactNativeWebView?.postMessage(
						JSON.stringify({
							type: WebViewMessageTypes.CLEAR_CACHE_REQUEST,
							payload: {},
						}),
					);
					window.location.href = "/";
				}}
			>
				{t(Resources.Errors.ApplicationError.Home)}
			</Button>

			<br />

			<Typography>Jste programátor? Koukněte v čem byla chyba.</Typography>

			<pre>
				<code>{JSON.stringify(error?.name)}</code>
			</pre>
			<pre>
				<code>{JSON.stringify(error?.message)}</code>
			</pre>
		</UnauthenticatedLayout>
	);
};
